import * as React from "react";

import Config from "../Config";
import Commons from "../utils/Commons";
import EntitiesTree from "./EntitiesTree";
import RequestHelper from "../utils/RequestHelper";
import JsonTreeDataCreator from "../utils/JsonTreeDataCreator";
import EntitiesList from "./EntitiesList";
import StateGlobal from "../StateGlobal";

export default class TemplatesList extends EntitiesList {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            loading: false,
            searchString: "", // Added state to hold the search string
        };

        StateGlobal.getState();
    }

    updateTemplatesSelection = (aSelected) => {
        this.setState({ selected: aSelected });
    };

    componentDidMount() {
        if (!Config.aTemplates || StateGlobal.isTemplateJustCreated()) {
            this.loadTemplates();
            StateGlobal.resetTemplateJustCreated();
        }
    }

    loadTemplates = async () => {
        this.setState({ loading: true });
        let aTemplatesGroup = null;
        try {
            if (!Config.aAnpRepo.id) {
                throw new Error(
                    "Repository ID is missing. Please select proper repository in Report Creator configuration.!"
                );
            }
            const aObjGroup = await Commons.checkTemplatesObjGroup();

            if (!(aObjGroup && aObjGroup.hasOwnProperty("id"))) {
                throw new Error("Cannot get templates group!");
            }

            const productVersion = Config.getProductName();
            let includeRWF = "";
            if (productVersion === "ADONIS") {
                includeRWF = "&attribute=MFB_RWF_VERSION";
            }

            await RequestHelper.sendRequestSimple({
                request: Commons.createGatewayRequestUrl({
                    url: Config.anpRequestUrl.getObjectGroup
                        .replace(/%repo_id%/g, Config.aAnpRepo.id)
                        .replace(/%group_id%/g, aObjGroup.id)
                        .concat(productVersion === "ADONIS" ? "&attribute=MFB_RWF_VERSION" : ""),
                    dataType: "json",
                }),
                dataType: "json",
            }).then((aResponse) => {
                if (aResponse && aResponse.isErr) {
                    console.error(aResponse.message);
                    throw new Error(aResponse.message);
                }
                if (
                    !(
                        aResponse.hasOwnProperty("group") &&
                        aResponse.group.hasOwnProperty("objects") &&
                        Array.isArray(aResponse.group.objects) &&
                        0 < aResponse.group.objects.length
                    )
                ) {
                    throw new Error("Cannot find any template in templates group!");
                }
                aTemplatesGroup = aResponse;
            });

            Config.setTemplates(aTemplatesGroup);
        } catch (aEx) {
            console.error(aEx);
            Config.setTemplates({
                group: null,
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    // New function to filter the tree data based on the search string
    filterTreeData(treeData, searchString) {
        function filterNode(node) {
            let filteredNode = {};

            for (let key in node) {
                if (key.toLowerCase().includes(searchString.toLowerCase())) {
                    filteredNode[key] = node[key];
                } else if (typeof node[key] === "object" && !Array.isArray(node[key])) {
                    let childNode = filterNode(node[key]);
                    if (Object.keys(childNode).length > 0) {
                        filteredNode[key] = childNode;
                    }
                }
            }
            return filteredNode;
        }

        return filterNode(treeData);
    }

    // Handle search input changes
    handleSearchChange = (event) => {
        this.setState({ searchString: event.target.value });
    };

    render() {
        const aPreSelected = Array.isArray(this.props.selected) ? this.props.selected : [];
        const { searchString, loading } = this.state;
        const originalTreeData = JsonTreeDataCreator.entitiesGroupTree(Config.aTemplates, false, true);
        const filteredTreeData = this.filterTreeData(originalTreeData, searchString); // Apply filtering

        return (
            <div>
                {/* Search input for filtering */}
                {!loading && <div className="search-container">
                    <input
                        autoFocus 
                        className="search-input"
                        type="text"
                        placeholder="Search templates..."
                        value={searchString}
                        onChange={this.handleSearchChange}
                    />
                </div>}
                {loading ? (
                    <div style={{ marginBottom: "20px" }}>
                        <h3 className="App__infoMessage">
                            {Config.strings.messages.templatesList.loading}
                        </h3>
                    </div>
                ) : (
                    <>
                        {Config.aTemplates?.group && (
                            <EntitiesTree
                                treeData={filteredTreeData} // Use the filtered tree data
                                multiSelect={false}
                                selectionCallback={this.updateTemplatesSelection}
                                selected={aPreSelected}
                                toggle={true}
                            />
                        )}
                    </>
                )}
            </div>
        );
    }
}
